import { render, staticRenderFns } from "./dspSetting.vue?vue&type=template&id=24e23115&scoped=true&"
import script from "./dspSetting.vue?vue&type=script&lang=js&"
export * from "./dspSetting.vue?vue&type=script&lang=js&"
import style0 from "./dspSetting.vue?vue&type=style&index=0&id=24e23115&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e23115",
  null
  
)

export default component.exports